import { ApiClient, buildQuery } from './client';

export interface BackofficeReward {
  id: string;
  scope: string;
  companyId: string | null;
  type: string;
  title: string | null;
  titleTranslation: string | null;
  description: string | null;
  descriptionTranslation: string | null;
  imageUrl: string | null;
  cost: number;
  active: boolean;
  comingSoon: boolean;
  createdAt: number;
}

export interface RewardFormData {
  type: string;
  title: string;
  titleTranslation?: string | null;
  description?: string | null;
  descriptionTranslation?: string | null;
  imageUrl?: string | null;
  cost: number;
  active?: boolean;
  comingSoon?: boolean;
}

export const backofficeRewardsAPI = {
  list: (status?: 'active' | 'inactive' | 'all') =>
    ApiClient.get<{ items: BackofficeReward[]; supportedTypes: string[] }>(
      `/backoffice/rewards${buildQuery({ status })}`
    ),
  create: (data: RewardFormData) => ApiClient.post<BackofficeReward>('/backoffice/rewards', data),
  update: (id: string, data: Partial<RewardFormData>) =>
    ApiClient.patch<BackofficeReward>(`/backoffice/rewards/${id}`, data),
  remove: (id: string) => ApiClient.delete<{ ok: boolean }>(`/backoffice/rewards/${id}`),
  uploadImage: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return ApiClient.postFormData<{ url: string }>('/backoffice/rewards/upload-image', fd);
  },
};
